import classNames from 'classnames';
import { ButtonHTMLAttributes, DOMAttributes, FC, PropsWithChildren, RefAttributes } from 'react';

import { ButtonSizes, ButtonVariant } from './Button.types';

import css from './Button.module.scss';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, RefAttributes<HTMLButtonElement> {
  className?: string;
  isResponsive?: boolean;
  size?: ButtonSizes;
  variant?: ButtonVariant;
  innerRef?: React.RefObject<HTMLButtonElement | null>;
}

const handleOnClick = (disabled: boolean, cb?: DOMAttributes<HTMLButtonElement>['onClick']) => {
  return (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    if (
      // Chrome version < 116 does not handle disabled attribute for bubbling
      event.currentTarget.disabled ||
      // handle when in devTools user removes attribute "disabled"
      disabled
    ) {
      event.preventDefault();
      return;
    }
    cb && cb(event);
  };
};

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  onClick,
  className,
  type = 'button',
  isResponsive = false,
  size = ButtonSizes.LG,
  children,
  disabled = false,
  variant = ButtonVariant.PRIMARY,
  innerRef,
  ...rest
}) => {
  return (
    <button
      onClick={handleOnClick(disabled, onClick)}
      className={classNames(
        css['custom-btn'],
        {
          [css[`custom-btn__${size}`]]: size,
          [css['custom-btn__is-responsive']]: isResponsive,
        },
        [css[`custom-btn__${variant}`], className],
      )}
      type={type}
      disabled={disabled}
      data-testid="button"
      ref={innerRef}
      {...rest}
    >
      {children}
    </button>
  );
};
